import { render, staticRenderFns } from "./pici.vue?vue&type=template&id=3635b702&scoped=true"
import script from "./pici.vue?vue&type=script&lang=js"
export * from "./pici.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635b702",
  null
  
)

export default component.exports